import { Col, Divider, Row } from 'antd';
import { useSelector } from 'react-redux';
import { CLAIMS_SETTINGS_COMPANY_STATUS, YES_NO_OPTIONS } from '../../../../../../contants/common';
import FormDatePicker from '../../../../../components/Inputs/FormDatePicker';
import FormInput from '../../../../../components/Inputs/FormInput';
import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';
import SecondaryLabel from '../../../../../components/Labels/SecondaryLabel';
import TMSFiledCard from '../../../../common/components/TMSFiledCard';
import ClaimsSettingsCompanyAddressForm from './ClaimsSettingsCompanyAddressForm';

const ClaimsSettingsCompanyForm = () => {
  const companyDetails = useSelector((state) => state.auth.selectedCompany);

  return (
    <div>
      <Row gutter={15}>
        <Col md={6}>
          <TMSFiledCard title="Company Name" containerClass="mb-10 mt-5">
            {companyDetails?.companyName}
          </TMSFiledCard>
          <FormInput editMode label="Short Name" margin="mb-10" />
          <FormInput editMode={false} label="Number" margin="m-0" inputType="number" />
        </Col>
        <Col md={6}>
          <FormDatePicker editMode label="Activation Date" margin="mb-10" placeholder="Select activation date" />
          <FormInput editMode label="Pro Number Priority" margin="m-0" inputType="number" />
        </Col>
        <Col md={6}>
          <FormSelectBox
            editMode
            label="Status"
            placeholder="Select status"
            margin="mb-10"
            options={CLAIMS_SETTINGS_COMPANY_STATUS}
          />
          <FormSelectBox
            editMode
            label="Append Items Only to Existing BOL"
            placeholder="Select append items only to existing BOL"
            margin="mb-0"
            options={YES_NO_OPTIONS}
          />
        </Col>
        <Col md={6}>
          <FormSelectBox
            editMode
            label="Batching Status"
            placeholder="Select batching status"
            margin="mb-10"
            options={YES_NO_OPTIONS}
          />
          <FormSelectBox
            editMode
            label="Batch Splits Allowed"
            placeholder="Select batch splits allowed"
            margin="mb-0"
            options={YES_NO_OPTIONS}
          />
        </Col>
      </Row>
      <Row className="mt-10" gutter={15}>
        <Col md={12}>
          <Row className="my-5" gutter={15} align="middle">
            <Col>
              <SecondaryLabel>Contact Type</SecondaryLabel>
            </Col>
            <Col className="flex-1 pt-3">
              <Divider className="m-0 border-top-border" />
            </Col>
          </Row>
          <ClaimsSettingsCompanyAddressForm />
        </Col>
        <Col md={12}>
          <Row className="my-5" gutter={15} align="middle">
            <Col>
              <SecondaryLabel>Company Type</SecondaryLabel>
            </Col>
            <Col className="flex-1 pt-3">
              <Divider className="m-0 border-top-border" />
            </Col>
          </Row>
          <ClaimsSettingsCompanyAddressForm />
        </Col>
      </Row>
    </div>
  );
};

export default ClaimsSettingsCompanyForm;
